var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "12px",
    viewBox: "0 0 9 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---1-edytor",
    transform: "translate(-316.000000, -776.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dodaj-artykul",
    transform: "translate(233.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(37.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(46.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7109375,13 C6.00260417,13 7.02473958,12.7083333 7.77734375,12.125 C8.52994792,11.5416667 8.90625,10.7291667 8.90625,9.6875 C8.90625,8.953125 8.74609375,8.36458333 8.42578125,7.921875 C8.10546875,7.47916667 7.58333333,7.17708333 6.859375,7.015625 L6.859375,7.015625 L6.859375,6.9375 C7.390625,6.84895833 7.81640625,6.5859375 8.13671875,6.1484375 C8.45703125,5.7109375 8.6171875,5.15104167 8.6171875,4.46875 C8.6171875,3.46354167 8.25130208,2.73046875 7.51953125,2.26953125 C6.78776042,1.80859375 5.61197917,1.578125 3.9921875,1.578125 L3.9921875,1.578125 L0.4375,1.578125 L0.4375,13 L4.7109375,13 Z M4.265625,6.1015625 L2.859375,6.1015625 L2.859375,3.5625 L4.1328125,3.5625 C4.82552083,3.5625 5.33203125,3.65755208 5.65234375,3.84765625 C5.97265625,4.03776042 6.1328125,4.3515625 6.1328125,4.7890625 C6.1328125,5.2578125 5.98567708,5.59375 5.69140625,5.796875 C5.39713542,6 4.921875,6.1015625 4.265625,6.1015625 L4.265625,6.1015625 Z M4.4375,11 L2.859375,11 L2.859375,8.0234375 L4.359375,8.0234375 C5.71354167,8.0234375 6.390625,8.49739583 6.390625,9.4453125 C6.390625,9.97135417 6.23177083,10.3619792 5.9140625,10.6171875 C5.59635417,10.8723958 5.10416667,11 4.4375,11 L4.4375,11 Z",
    id: "B"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBold);
export default __webpack_public_path__ + "static/media/optionBold.543e6eb37d9df1e8fa0f44639f6a18bd.svg";
export { ForwardRef as ReactComponent };